module.exports = __webpack_public_path__ + "static/media/app-layer.31225336.png";